var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageWrapper',_vm._l((_vm.activeComponents),function(component,index){return (component.active)?_c(component.name,_vm._b({key:index,tag:"Component",attrs:{"id":`component_${component.id}`,"component":component,"index":index}},'Component',component.options,false)):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }